import fetchIntercept from 'fetch-intercept'
import Molten from '@leverege/molten'
import Config from './Config'
import PluginSetup from './PluginSetup'

import './global-style.css'

function start( opts = { } ) {
  fetchIntercept.register( {
    responseError( err ) {
      if ( err.message === 'Failed to fetch' ) {
        console.error( err )
        return Promise.reject( new Error( 'Network Connection Issue. Please Retry' ) )
      }

      return Promise.reject( err )
    }
  } )

  const cfg = Config.create()

  Molten.init( cfg )
  
  // Add plugins
  PluginSetup.install( Molten )

  Molten.create( )

}

window.Application = { start }

document.addEventListener( 'DOMContentLoaded', start )
